import React from 'react';
import { Bell, AlertTriangle, Clock, TrendingUp } from 'lucide-react';
import { useIFAlertas } from '../hooks/useIFAlertas';
import { useNavigate } from 'react-router-dom';

const TIPO_CONFIG: Record<string, { icon: React.ElementType; label: string; color: string; bg: string }> = {
  risco_elevado:   { icon: AlertTriangle, label: 'Risco',   color: 'text-destructive', bg: 'bg-destructive/10' },
  prazo_critico:   { icon: Clock,         label: 'Prazo',   color: 'text-destructive', bg: 'bg-destructive/10' },
  desvio_progresso:{ icon: TrendingUp,    label: 'Desvio',  color: 'text-warning',     bg: 'bg-warning/10' },
  boletim_aprovado:{ icon: Bell,          label: 'Boletim', color: 'text-muted-foreground', bg: 'bg-muted' },
};

export const IFAlertasBanner: React.FC = () => {
  const { data: alertas = [] } = useIFAlertas();
  const navigate = useNavigate();

  if (alertas.length === 0) return null;

  // Group counts by tipo
  const counts = alertas.reduce<Record<string, number>>((acc, a) => {
    acc[a.tipo] = (acc[a.tipo] || 0) + 1;
    return acc;
  }, {});

  return (
    <div
      className="flex items-center gap-3 p-3 rounded-lg border border-destructive/30 bg-destructive/5 cursor-pointer hover:bg-destructive/10 transition-colors"
      onClick={() => navigate('/financiamento/alertas')}
    >
      <Bell className="h-5 w-5 text-destructive shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1.5 flex-wrap">
          {Object.entries(counts).map(([tipo, count]) => {
            const cfg = TIPO_CONFIG[tipo] || { icon: Bell, label: tipo, color: 'text-muted-foreground', bg: 'bg-muted' };
            const Icon = cfg.icon;
            return (
              <span
                key={tipo}
                className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold ${cfg.color} ${cfg.bg}`}
              >
                <Icon className="h-3 w-3" />
                {count} {cfg.label}
              </span>
            );
          })}
        </div>
        <p className="text-[10px] text-muted-foreground mt-0.5">Clique para ver detalhes</p>
      </div>
      <span className="text-xs font-bold text-destructive shrink-0">{alertas.length}</span>
    </div>
  );
};
